export default __webpack_public_path__ + "static/media/currentPortfolio.7b78c06e.png";